import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';

import { ApplicationFacade, RelatedCardFacade } from '@ridango/components';

@Component({
    templateUrl: './related-card-add-and-edit-page.component.html',
    styleUrls: ['./related-card-add-and-edit-page.component.scss']
})
export class RelatedCardAddAndEditPageComponent implements OnInit, OnDestroy {
    assetsPath$ = this.applicationFacade.assetsPath$;

    constructor(
        private applicationFacade: ApplicationFacade,
        private translate: TranslateService,
        private router: Router,
        public route: ActivatedRoute,
        private relatedCardFacade: RelatedCardFacade
    ) {}

    cardId: number;

    ngOnInit() {
        this.cardId = +this.route.snapshot.params.id;

        if (this.cardId) {
            this.relatedCardFacade.setEditMode(true);
        }
    }

    ngOnDestroy(): void {
        this.relatedCardFacade.setEditMode(false);
    }

    back() {
        this.router.navigate([this.translate.currentLang, 'account']);
    }

    handleSaveSuccess() {
        this.router.navigate([this.translate.currentLang, 'account']);
    }
}
